import React from "react";

const FilterList = () => {
  const filters = [
    {
      id: 1,
      name: "Size",
      type: "Dropdown",
      options: ["S", "M", "L", "XL"],
    },
    {
      id: 2,
      name: "Color",
      type: "Checkbox",
      options: ["Red", "Green", "Blue"],
    },
    {
      id: 3,
      name: "Price",
      type: "Range",
      options: ["₹0 - ₹999", "₹1000 - ₹4999", "₹5000+"],
    },
    {
      id: 4,
      name: "Brand",
      type: "Dropdown",
      options: ["Nike", "Puma", "Adidas"],
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Filter List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Product Settings</a>
                </li>
                <li className="breadcrumb-item active">Filter List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Filter Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="d-flex card-header justify-content-between align-items-center">
                <h4 className="card-title">All Filters</h4>
                <a href="#!" className="btn btn-sm btn-outline-light rounded">
                  Add Filter
                </a>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table align-middle mb-0 table-hover table-centered">
                    <thead className="bg-light-subtle">
                      <tr>
                        <th style={{ width: 20 }}>
                          <div className="form-check fs-16 ms-1">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="filterCheckAll"
                            />
                          </div>
                        </th>
                        <th>ID</th>
                        <th>Filter Name</th>
                        <th>Type</th>
                        <th>Options</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filters.map((filter) => (
                        <tr key={filter.id}>
                          <td>
                            <div className="form-check fs-16 ms-1">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`filterCheck${filter.id}`}
                              />
                            </div>
                          </td>
                          <td>{filter.id}</td>
                          <td>{filter.name}</td>
                          <td>{filter.type}</td>
                          <td>{filter.options.join(", ")}</td>
                          <td>
                            <div className="d-flex gap-2">
                              <a href="#!" className="btn btn-light btn-sm">
                                <i className="fa-solid fa-eye fs-16"></i>
                              </a>
                              <a href="#!" className="btn btn-soft-primary btn-sm">
                                <i className="fa-solid fa-pencil fs-16"></i>
                              </a>
                              <a href="#!" className="btn btn-soft-danger btn-sm">
                                <i className="fa-solid fa-trash fs-16"></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Footer Pagination (static) */}
              <div className="card-footer border-top">
                <nav aria-label="Page navigation">
                  <ul className="pagination justify-content-end mb-0">
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        Previous
                      </a>
                    </li>
                    <li className="page-item active">
                      <a className="page-link" href="javascript:void(0);">
                        1
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        2
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 text-center">
                © Venton. Crafted by{" "}
                <iconify-icon
                  icon="iconamoon:heart-duotone"
                  className="fs-18 align-middle text-danger"
                />{" "}
                <a href="#" className="fw-bold footer-text" target="_blank">
                  Techzaa
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default FilterList;
